module.exports = __webpack_public_path__ + "assets/b11662265d90301564e696c3da83b2aa.png";